/**
 * Format elapsed time in milliseconds to MM:SS or H:MM:SS format
 * 
 * @param {number} ms - Elapsed time in milliseconds
 * @returns {string} Formatted time string (e.g., "01:23", "1:02:45")
 */
export function formatElapsedTime(ms) {
  // Handle invalid or negative values
  if (ms == null || isNaN(ms) || ms < 0) {
    return '00:00';
  }

  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Pad with leading zero
  const pad2 = (num) => String(num).padStart(2, '0');

  // Format: H:MM:SS for >= 1 hour, MM:SS for < 1 hour
  if (hours > 0) {
    return `${hours}:${pad2(minutes)}:${pad2(seconds)}`;
  }

  return `${pad2(minutes)}:${pad2(seconds)}`;
}
